import { render, staticRenderFns } from "./ElevatDetails.vue?vue&type=template&id=6ed282d1&scoped=true&"
import script from "./ElevatDetails.vue?vue&type=script&lang=js&"
export * from "./ElevatDetails.vue?vue&type=script&lang=js&"
import style0 from "./ElevatDetails.vue?vue&type=style&index=0&id=6ed282d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed282d1",
  null
  
)

export default component.exports